module.exports = __webpack_public_path__ + "static/Hero-Banner-Manufacturing-2-32ce7d9c2c658b5c724059026abd29c6.jpg";